export default __webpack_public_path__ + "assets/images/a950eca777a4ef5f913a5f644be41af9.png";